import { useEffect, useState } from "react";
import { getColumns, getPillCategoriesList } from "./PillCategoriesData";
import { pillCategoriesDelete } from "../../api/HttpApis";
import PillCategoriesModal from "./pillCategorieModal";
import { GoPlus } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";
import CommonTable from "../../component/commonTable/CommonTable";
import Button from "../../component/button/Button";
import { showToast } from "../../utils/Toastify/Toastify";

const PillCategories = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pillCategoriesData, setPillCategoriesData] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [handleEditId, setHandleEditId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [radioValue, setRadioValue] = useState("genre");
  const [showGenres, setShowGenres] = useState(true);
  const fetchData = async (page, limit) => {
    try {
      const data = await getPillCategoriesList(page, limit);
      setPillCategoriesData(data);
      setTotalCount(data.totalCount);
    } catch (error) {
      showToast(error.response?.data?.message, "error");
    }
  };
  useEffect(() => {
    if (location.state?.openModal) {
      setIsModalOpen(true);
      setHandleEditId(null);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);
  const handleEdit = (id) => {
    setHandleEditId(id);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmed) return;
    setDeletingId(id);
    try {
      const response = await pillCategoriesDelete(id);
      setPillCategoriesData((prev) => prev.filter((item) => item.id !== id));
      setTotalCount((prev) => Math.max(0, prev - 1));
      showToast(response?.data?.message, "success");
    } catch (error) {
      showToast(error?.response?.data?.message);
    } finally {
      setDeletingId(null);
    }
  };
  const handleClick = () => {
    setIsModalOpen(true);
    setRadioValue("genre");
    setShowGenres(true)
}
  const Columns = getColumns(handleEdit, handleDelete, deletingId);
  return (
    <div>
      <CommonTable
        heading={false}
        Library="Pill Categories"
        columns={Columns}
        onPageChange={fetchData}
        data={pillCategoriesData}
        totalCount={totalCount}
        para="Provide categories for users toto browse regualarly or seasonally. These will show in the Streaming environment "
        button={false}
        extraButton={
          <Button
            iconRight={<GoPlus />}
            type="button"
            selectLabel="Category"
            onClick={handleClick}
          >
            Category
          </Button>
        }
        Category={false}
      />
      <PillCategoriesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onInviteSuccess={fetchData}
        handleEditId={handleEditId}
        setHandleEditId={setHandleEditId}
        setRadioValue={setRadioValue}
        radioValue={radioValue}
        setShowGenres={setShowGenres}
        showGenres={showGenres}
        
      />
    </div>
  );
};

export default PillCategories;
